<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-10-19 11:54:02
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-11-17 12:15:20
 * @FilePath: /chaoyongtuan/src/views/shopManage/commercialHigh/components/goodsList/goodsList.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="goods-table">
		<div class="goods-table-content mt-16">
			<template v-if="lazyState">
				<div class="goods-item-li" v-for="(item, index) in createArray" :key="index">
					<goods-item :lazyState="lazyState" :info="item" :platformId="platformId" />
				</div>
			</template>
			<template v-else>
				<div class="goods-item-li" v-for="(item, index) in list" :key="index">
					<goods-item :lazyState="lazyState" :info="item" :platformId="platformId" />
				</div>
			</template>
		</div>
	</div>
</template>
<script>
import goodsItem from '../goodItem/index';
import { PLATFORM_DY } from '@/utils/dataMap';
export default {
	props: {
		list: {
			type: Array,
			default: () => [{}],
		},
		platformId: {
			type: [Number, String],
			default: PLATFORM_DY.value,
		},
		lazyState: {
			type: Boolean,
			default: false,
		},
		skeletonCount:{
			type: Number,
			default: 20,
		}
	},
	components: {
		goodsItem,
	},
	computed:{
		createArray() {
			let arr = [];
			for (let i = 0; i < this.skeletonCount; i++) {
				arr.push(i);
			}
			return arr;
		}
	},
	data() {
		return {
			goodsItem: [],
		};
	},
	methods: {

	},
	created() {
		this.goodsItem = this.list;
	},
};
</script>
<style lang="less" scoped>
.goods-table {
	width: 100%;
	.goods-table-content {
		display: flex;
		flex-wrap: wrap;
		.goods-item-li {
			margin-right: 16px;
			margin-bottom: 16px;
		}
		.goods-item-li:nth-child(5n) {
			margin-right: 0px;
		}
	}
}
</style>
